import { render, staticRenderFns } from "./TrasferenceDetails.vue?vue&type=template&id=5d7e0d94&scoped=true&"
import script from "./TrasferenceDetails.vue?vue&type=script&lang=js&"
export * from "./TrasferenceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e0d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7e0d94')) {
      api.createRecord('5d7e0d94', component.options)
    } else {
      api.reload('5d7e0d94', component.options)
    }
    module.hot.accept("./TrasferenceDetails.vue?vue&type=template&id=5d7e0d94&scoped=true&", function () {
      api.rerender('5d7e0d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/transferences/TrasferenceDetails.vue"
export default component.exports